import styled from '@emotion/styled';

interface Document {
	name: string;
	url: string;
}

const Section = styled.section`
	padding: 2rem 1.5rem 3rem;
	background: white;
`;

const Inner = styled.div`
	max-width: 64rem;
	margin: 0 auto;
`;

const Title = styled.h2`
	text-transform: uppercase;
	font-size: 1.5rem;
	margin-bottom: 1.5rem;
`;

const List = styled.div`
	display: grid;
	gap: 1rem;
`;

const Item = styled.a`
	display: flex;
	align-items: center;
	gap: 1rem;
	padding: 1rem 1.5rem;
	border: 1px solid #d1d5db;
	box-shadow: 11px 8px 0px #444;
	text-transform: uppercase;
	text-decoration: none;
	color: inherit;
`;

export default function DocumentBlockBeta({ documents }: { documents: Document[] }) {
	if (documents.length === 0) return null;

	return (
		<Section id="documents">
			<Inner>
				<Title>Documents &amp; Brochures</Title>
				<List>
					{documents.map((doc) => (
						<Item key={doc.url} href={doc.url} target="_blank" rel="nofollow">
							<span>PDF</span>
							<span>{doc.name}</span>
						</Item>
					))}
				</List>
			</Inner>
		</Section>
	);
}
